__turbopack_context__.v({
  "bodyWrapper": "Body-module-scss-module__i1SLCG__bodyWrapper",
  "contentContainer": "Body-module-scss-module__i1SLCG__contentContainer",
  "heroAndBannerSection": "Body-module-scss-module__i1SLCG__heroAndBannerSection",
  "layoutWrapper": "Body-module-scss-module__i1SLCG__layoutWrapper",
  "mainContent": "Body-module-scss-module__i1SLCG__mainContent",
});
